module.exports = __webpack_public_path__ + "img/zeit.d0771743.svg";